import { z } from "zod";

export const resetPasswordResponseSchema = z.object({
  result: z.boolean(),
  resultCode: z.string(),
});

export type ResetPasswordResponseType = z.infer<typeof resetPasswordResponseSchema>;
